import api from './api.service';

type registerType = {
    email: string;
    password: string;
    first_name: string;
    last_name: string
}

class RegisterService {
    private url: string = 'auth/register';

    register(data: registerType) {
        return api.post(this.url, data, {
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        });
    }
}

export const registerService = new RegisterService();
